<template>
  <div class="NPS questionWrap">
    <div class="textWrap">
      <p class="label left">{{ $t("unlikely") }}</p>
      <p class="label right">{{ $t("likely") }}</p>
    </div>
    <div class="rating">
      <a
        class="item"
        v-for="(num, index) in 11"
        :key="index"
        href="javascript:void(0)"
        :class="[currentButtonType, { active: index <= chooseArray[0] }]"
        @click="chooseEvent(index)"
      >
        <span v-if="currentButtonType === 'number'">{{ index }}</span>
      </a>
    </div>
  </div>
</template>

<script lang="ts" setup>
import answerHook from "../../hooks/answerHook";
const { chooseEvent, commonAnswerInfo, chooseArray, currentButtonType } =
  answerHook();
</script>
<style lang="scss" scoped>
@import "@/assets/scss/mixin.scss";
.NPS {
  width: 100%;
  height: 150px;
  @media (orientation: landscape) {
    height: 150px;
  }
  .textWrap {
    color: #999;
    font-size: 20px;
    display: flex;
    justify-content: space-between;
    width: 100%;
    margin: 0 auto 20px;
    @media (orientation: landscape) {
      font-size: 20px;
      margin: 0 auto 20px;
    }
    .label {
      box-sizing: border-box;
      padding: 10px;
      border-radius: 10px;
      background-color: #eee;
      @media (orientation: landscape) {
        padding: 10px;
        border-radius: 10px;
      }
    }
  }
  .rating {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    .item {
      cursor: pointer;
      display: flex;
      &.number {
        flex: 1;
        height: 45px;
        background: #f7f7f7;
        justify-content: center;
        align-items: center;
        color: #000;
        border: 1px solid #ece8e8;
        font-size: 15px;
        @media (orientation: landscape) {
          height: 45px;
          border: 1px solid #ece8e8;
          font-size: 15px;
        }
        &.active {
          color: #fff;
          background: $btnColor;
          border-color: $btnColor;
        }
      }
      &.finger {
        @include setBackground(35px, 30px, "thumb_gray.png");
        background-size: 100% 100%;
        @media (orientation: landscape) {
          width: 35px;
          height: 30px;
        }
        &.active {
          background-image: url($imgURL + "thumb.png");
        }
      }
    }
  }
}
</style>
